// Vue.config.devtools = true;
import { createApp } from "vue";

let app = createApp({});
app.component(
  "vue-article-list",
  require("./components/VueArticleList.vue").default
);
var VueResource = require("vue-resource");

// Install plugins.
app.use(VueResource);

app.mount("#app");
